package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_06_16_Day_1
import com.veldekar.components.logs.Log_2023_06_16_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-06-16")
@Composable
public fun Log_2023_06_16(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "River Cave Ingress",
        ogTitle = "River Cave Ingress",
        date = LocalDate(2_023, 6, 16),
        ogDescription = "Joined by dwarves Shail and Dworlan, the party takes boats into an echoing river cave system beneath the mountains.",
        ogImage = "ai/2023-06-16.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
        Log_2023_06_16_Day_1()
        SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
        Log_2023_06_16_Day_2()
    }
}
